var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="modal-header"> <button type="button"class="close"data-dismiss="modal"aria-hidden="true"> &times; </button> <h4 class="modal-title"><b>Обращение в службу поддержки</b></h4> </div> <div class="modal-body"data-bind="template: _template()"></div>';
}
return __p;
};
